import { render, staticRenderFns } from "./DownloadsPages.vue?vue&type=template&id=00a6f22f&"
import script from "./DownloadsPages.vue?vue&type=script&lang=js&"
export * from "./DownloadsPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports